module.exports = __webpack_public_path__ + "img/Shape.cbcbb5a4.svg";